import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const SOLD_REPORTS_URL = `${API_URL}/devices`;

// Get Sold Reports
export const getSoldReports = createAsyncThunk(
  "soldReports/getSoldReports",
  async (params: { page: number; limit: number; search?: string; startDate?: string; endDate?: string }) => {
    const response = await axios.get(`${SOLD_REPORTS_URL}/sold-reports`, { params });
    return response.data;
  }
);
